<script setup lang="ts">
import "./MStatChipBar.scss";
import { computed } from "vue";
import MStatChip from "../MStatChip/MStatChip.vue";
import type { MStatChipBarProps, MStatChipItem } from "./MStatChipBar.props";
import { mStatChipBarDefaults } from "./MStatChipBar.props";

const props = withDefaults(defineProps<MStatChipBarProps>(), mStatChipBarDefaults);

const emit = defineEmits<{
  chipClick: [item: MStatChipItem, index: number];
  "update:modelValue": [value: string[]];
}>();

const classes = computed(() => ["m-stat-chip-bar", props.bare && "m-stat-chip-bar--bare"]);

function isSelected(item: MStatChipItem): boolean {
  if (props.modelValue !== undefined) return props.modelValue.includes(item.label);
  return item.selected ?? false;
}

function handleChipClick(item: MStatChipItem, index: number): void {
  emit("chipClick", item, index);
  if (!props.selectionMode) return;

  const current = props.modelValue ?? [];
  if (props.selectionMode === "single") {
    emit("update:modelValue", current.includes(item.label) ? [] : [item.label]);
  } else {
    emit(
      "update:modelValue",
      current.includes(item.label)
        ? current.filter((l) => l !== item.label)
        : [...current, item.label],
    );
  }
}
</script>

<template>
  <div :class="classes" role="group" :aria-label="ariaLabel">
    <slot>
      <MStatChip
        v-for="(item, i) in items"
        :key="i"
        v-bind="item"
        :selected="isSelected(item)"
        @click="handleChipClick(item, i)"
      />
    </slot>
  </div>
</template>
